import { render, staticRenderFns } from "./MassChange.vue?vue&type=template&id=89ad76e0&scoped=true&"
import script from "./MassChange.vue?vue&type=script&lang=js&"
export * from "./MassChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ad76e0",
  null
  
)

export default component.exports